export const desktopWrapperStyle = {
    position: 'fixed',
    bottom: '24px',
    right: '24px',
    zIndex: 2147483647,
    borderRadius: '16px',
    background: '#ffffff',
    boxSizing: 'content-box',
    boxShadow: '0 8px 40px rgba(0,0,0,0.18), 0 2px 8px rgba(0,0,0,0.08)',
    overflow: 'hidden',
    fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
    display: 'flex',
    flexDirection: 'column'
};

export const desktopClosedWrapperStyleChat = {
    position: 'fixed',
    bottom: '24px',
    right: '24px',
    zIndex: 2147483647,
    minWidth: '340px',
    boxSizing: 'content-box',
    overflow: 'visible',
    minHeight: '80px'
};

export const mobileClosedWrapperStyle = {
    position: 'fixed',
    // env() safe-area for iPhone X+ home indicator bar
    bottom: 'calc(env(safe-area-inset-bottom, 0px) + 16px)',
    right: '16px',
    zIndex: 2147483647,
    borderRadius: '50%',
    boxSizing: 'content-box'
};

// mobileOpenWrapperStyle is built dynamically in widget.js
// using the real viewport height to avoid iOS 100vh bug
export const mobileOpenWrapperBase = {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    zIndex: 2147483647,
    background: '#ffffff',
    boxSizing: 'content-box',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden'
};

export const desktopTitleStyle = {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '0 16px',
    fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
    cursor: 'pointer',
    flexShrink: 0
};

export const mobileTitleStyle = {
    height: 56,
    width: 56,
    cursor: 'pointer',
    borderRadius: '50%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    boxShadow: '0 4px 16px rgba(0,0,0,0.22)',
    // Prevent double-tap zoom on mobile
    touchAction: 'manipulation',
    WebkitTapHighlightColor: 'transparent'
};



// WEBPACK FOOTER //
// ./src/widget/style.js